<svg width="14" height="14" viewBox="0 0 14 14" fill="#1A1A1A" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_169_9744)">
<path d="M14 13.1752L13.1752 14L7 7.82483L0.824833 14L0 13.1752L6.17517 7L0 0.824834L0.824833 4.76837e-07L7 6.17517L13.1752 4.76837e-07L14 0.824834L7.82483 7L14 13.1752Z" />
</g>
<defs>
<clipPath id="clip0_169_9744">
<rect width="14" height="14" fill="white" transform="matrix(1 0 0 -1 0 14)"/>
</clipPath>
</defs>
</svg>
